import React from 'react';
import { Globe, MapPin, Building2, Star, Calendar, Sparkles } from 'lucide-react';
import { COUNTRIES } from '@/data/mockData';
import { TRAVEL_STORIES, EVENTS } from '@/data/discoveryData';
import { TOURIST_ESSENTIALS } from '@/data/touristEssentials';
import { useStats } from '@/hooks/useStats';

export const InvestorStats = () => {
  const { stats: live } = useStats();
  const businesses = live?.listings ?? 0;
  const destinations = live?.cities ?? 0;
  const avgRating = live?.avg_rating ?? 4.7;
  const stats = [
    { icon: Globe,     value: COUNTRIES.filter(c => c.available).length, label: 'Countries',   color: '#00AA6C' },
    { icon: MapPin,    value: destinations || '—',                       label: 'Destinations', color: '#D32323' },
    { icon: Building2, value: businesses ? `${businesses}+` : '—',        label: 'Businesses',   color: '#0F1929' },
    { icon: Star,      value: avgRating,                                  label: 'Avg rating',   color: '#F59E0B' },
    { icon: Calendar,  value: EVENTS.length,                              label: 'Live events',  color: '#9333EA' },
    { icon: Sparkles,  value: `${TRAVEL_STORIES.length + TOURIST_ESSENTIALS.length}`, label: 'Guides &amp; tips', color: '#0EA5E9' },
  ];

  return (
    <section className="py-10 bg-gradient-to-r from-[#0F1929] via-[#102032] to-[#1A2A40] text-white" data-testid="investor-stats">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-3 md:grid-cols-6 gap-4 sm:gap-6">
          {stats.map(s => {
            const Icon = s.icon;
            return (
              <div key={s.label} className="text-center" data-testid={`investor-stat-${s.label.toLowerCase().replace(/[^a-z]+/g,'-')}`}>
                <div className="w-10 h-10 mx-auto rounded-lg flex items-center justify-center mb-2" style={{ background: `${s.color}26` }}>
                  <Icon className="w-5 h-5" style={{ color: s.color }} />
                </div>
                <div className="font-heading text-2xl sm:text-3xl font-bold">{s.value}</div>
                <div className="text-[10px] sm:text-xs text-white/65 uppercase tracking-wider mt-0.5" dangerouslySetInnerHTML={{ __html: s.label }} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
